export enum LeadStatusEnum {
    Prospecting = 0,
    Negotiation = 1,
    Proposal = 2,
    Qualification = 3,
    Closed_Won = 4,
    Closed_Lost = 5
}